import script from "./NavigationBar.vue?vue&type=script&setup=true&name=NavigationBar&lang=js"
export * from "./NavigationBar.vue?vue&type=script&setup=true&name=NavigationBar&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=81a0946e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81a0946e"]])

export default __exports__